import Api from '../../shared/Api';
import { Promise } from 'es6-promise';
import IPhotographerInput from './IPhotographerInput';
import IPhotographer from './IPhotographer';

export class PhotographersApi {
    static addPhotographer(photographer: IPhotographerInput): Promise<any> {
        return new Api().post(`/views/photographers`, photographer);
    }

    static newPhotographer(): Promise<any> {
        return new Api().get('/views/photographers/new');
    }

    static listPhotographers(): Promise<any> {
        return new Api().get('/views/photographers');
    }
    static getEditPhotographer(id: number): Promise<any> {
        return new Api().get(`/views/photographers/${id}/edit`);
    }

    static getPhotographerPresentation(id: number): Promise<any> {
        return new Api().get(`/views/photographers/${id}/presentation`);
    }

    static getUpcomingDroneBookings(id: number): Promise<any> {
        return new Api().get(`/views/photographers/${id}/upcoming-drone-bookings`);
    }

    static getPhotographerFavoritedImages(id: number): Promise<any> {
        return new Api().get(`/views/photographers/${id}/favoritedimages`);
    }

    static getPhotographerCalendar(id: number, from: any, to: any): Promise<any> {
        let url =
            `/views/photographers/${id}/calendar` +
            '?fromYear=' +
            from.year() +
            '&fromMonth=' +
            (from.month() + 1) +
            '&fromDay=' +
            from.date() +
            '&toYear=' +
            to.year() +
            '&toMonth=' +
            (to.month() + 1) +
            '&toDay=' +
            to.date();
        return new Api().get(url);
    }

    static updatePhotographer(id: number, user: IPhotographerInput): Promise<any> {
        return new Api().put(`/views/photographers/${id}`, user);
    }

    static createCubiCasaConnection(id: number) {
        return new Api().post(`/views/photographers/${id}/cubicasa`, id);
    }

    static updatePhotographerWorkingHours(
        photographerId: number,
        se360WorkingHours: any[],
        scandphotosWorkingHours: any[]
    ) {
        return new Api().put('/views/photographer-calendars/working-hours', {
            photographerId: photographerId,
            se360WorkingHours: se360WorkingHours,
            scandphotosWorkingHours: scandphotosWorkingHours
        });
    }

    static async sendEmailToPhotographers(payload: {
        sender: string;
        subject: string;
        body: string;
        recipients: { id: number; name: string; email: string }[];
    }): Promise<any> {
        try {
            const response = await new Api().post('/views/photographers/send-email-to-photographers-in-region', payload);
            return response;
        } catch (error) {
            console.error('Error in sendEmailToPhotographers:', error);
            throw error;
        }
    }  
}

export default PhotographersApi;
